import { SocialRewardCampaign } from '@/models/social-rewards';
import APIService from '../api';

export default class SocialRewardsService extends APIService {
  createSocialRewardCampaign(data: SocialRewardCampaign) {
    return this.post('/admin/socialrewards', data);
  }

  updateSocialRewardCampaign(data: SocialRewardCampaign) {
    return this.put('/admin/socialrewards', data);
  }

  getSocialRewardsCampaigns() {
    return this.get<SocialRewardCampaign[]>('/admin/socialrewards');
  }
}
